import * as Sentry from '@sentry/react';

import { CenteredMessage } from './common/CenteredMessage';

export function ErrorBoundary(props) {
  return (
    <Sentry.ErrorBoundary
      showDialog={false}
      onError={(error, componentStack, eventId) => {
        Sentry.showReportDialog({ eventId: eventId });
      }}
      fallback={({ error, componentStack, resetError, eventId }) => {
        return (
          <CenteredMessage title="An error occured">
            {error.name}: {error.message}
          </CenteredMessage>
        );
      }}
    >
      {props.children}
    </Sentry.ErrorBoundary>
  );
}
